import { Pagination as Page, PaginationItem, PaginationLink } from "reactstrap";
import styles from "./pagination.module.scss";

const Pagination = ({ pageNumbers, currentPage, paginate }) => {
  return (
    <Page color="success" id={styles["mediatheque-pagination"]} className="pagination justify-content-end ">
      <PaginationItem disabled={currentPage <= 0} id={styles["pagination_item_prev"]}>
        <PaginationLink onClick={e => paginate(currentPage - 1, e)} previous></PaginationLink>
      </PaginationItem>
      {[...Array(pageNumbers)].map((page, index) => (
        <PaginationItem active={index === currentPage} key={index}>
          <PaginationLink onClick={e => paginate(index, e)}>{index + 1}</PaginationLink>
        </PaginationItem>
      ))}
      <PaginationItem disabled={currentPage >= pageNumbers - 1} id={styles["pagination_item_prev"]}>
        <PaginationLink onClick={e => paginate(currentPage + 1, e)} next></PaginationLink>
      </PaginationItem>
    </Page>
  );
};

export default Pagination;
